import { render, staticRenderFns } from "./SupEdit.vue?vue&type=template&id=44ba0047&scoped=true"
import script from "./SupEdit.vue?vue&type=script&lang=js"
export * from "./SupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba0047",
  null
  
)

export default component.exports